export default function CheckBox() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="checkbox">
        <rect
          id="Rectangle 999"
          x="1"
          y="1"
          width="20"
          height="20"
          rx="4"
          stroke="#6C6C6C"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}
